import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import toastr from 'toastr';
import { getRedirectSignInWithSSO, signInWithRedirectByProvider } from '../../../actions/auth/signIn';
import { selectAuth, TRY_SIGN_WITH_SSO } from '../../../redux/AuthSlice';
import { selectPortalInfo } from '../../../redux/PortalInfoSlice';
import { signInHandle } from '../../../actions/auth/signInHandle';

const SignInWithSSO = (props) => {
  const navigate = useNavigate()
  const { signInProvider } = props;
  const portalInfo = useSelector(selectPortalInfo);
  const auth = useSelector(selectAuth);
  const { settings } = portalInfo || {};
  const { 
    isPortalSingleSignOnEnabled = false, 
    portalSignInProvider,
  } = settings || {};

  const isSingleSignOnEnabled = portalSignInProvider && isPortalSingleSignOnEnabled;

  const query = useQuery();

  // WARNING: Do not put props in the dependency array to avoid an infinite loop when Firebase crashes
  useEffect(autoSignInWithRedirectSSO, [auth, isSingleSignOnEnabled, navigate, query, signInProvider]);

  return (
    <form className="d-flex flex-column" onSubmit={handleSubmit}>
        <div className="col-12 d-flex flex-column mt-3">
          <button type="submit" className="hui-btn hui-btn-xl hui-btn-icon">
            Sign Single On
          </button>
        </div>
    </form>
  );

  async function handleSubmit(e) {
    e.preventDefault();
    try {        
      sessionStorage.setItem(TRY_SIGN_WITH_SSO, true);
      await signInWithRedirectByProvider(signInProvider);
    } catch (error) {
      toastr.error(error);
      sessionStorage.removeItem(TRY_SIGN_WITH_SSO);
      props?.onChange(false);
    }
  }

  function useQuery() {
    const { search } = useLocation();
    return React.useMemo(() => new URLSearchParams(search), [search]);
  }

  function autoSignInWithRedirectSSO () {
    const onPageLoad = async () => {
      const signInWithSSO = sessionStorage.getItem(TRY_SIGN_WITH_SSO);
      const authFromRedirect = await getRedirectSignInWithSSO();
      const pathname = window.location.pathname;
      const _auth = auth || authFromRedirect?.user || authFromRedirect;
      const isLoggedIn = _auth?.uid;
      if (isLoggedIn) {
        const redirect = query.get('redirect') || 'dashboard';
        const result = await signInHandle();
        if (result.isLogged) {
          navigate(`/${redirect}`);
        } else if (result.isInviteApproved === false) {
          navigate(`/pending-approval`);
          sessionStorage.removeItem(TRY_SIGN_WITH_SSO);
        } else if (result.isEmailVerified === false) {
          navigate(`/confirm-email`);
          sessionStorage.removeItem(TRY_SIGN_WITH_SSO);
        } else if (result.userNotFound === true) {
          toastr.error('User not found');
          sessionStorage.removeItem(TRY_SIGN_WITH_SSO);
        } else if (result.noCustomerAccount) {
          toastr.error('We could not find any customer account for this user');
          sessionStorage.removeItem(TRY_SIGN_WITH_SSO);
        } else {
          toastr.error('Error logging in, please try again.');
          sessionStorage.removeItem(TRY_SIGN_WITH_SSO);
        }
        props?.onChange(false);
        return;
      }
      if (pathname === '/auth/sso' && !isLoggedIn && !signInWithSSO) {
        sessionStorage.setItem(TRY_SIGN_WITH_SSO, true);
        await signInWithRedirectByProvider(signInProvider);
      } else if (['/auth/sso', '/login'].includes(pathname) && signInWithSSO) {
        toastr.error('Could not find any customer accounts for this user');
        sessionStorage.removeItem(TRY_SIGN_WITH_SSO);
        props?.onChange(false);
      } else {
        sessionStorage.removeItem(TRY_SIGN_WITH_SSO);
        props?.onChange(false);
      }
    };

    if (isSingleSignOnEnabled) {
      try {
        onPageLoad();
      } catch (error) {
        console.log(error);
        sessionStorage.removeItem(TRY_SIGN_WITH_SSO);
        props?.onChange(false);
      }
    }
  }
};

export default SignInWithSSO;
